module.exports = __webpack_public_path__ + "static/media/deddou_mood.90249377.jpg";